import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

const resources = {
  de: {
    translation: {
      // Navigation
      'nav.home': 'Startseite',
      'nav.categories': 'Kategorien',
      'nav.wholesale': 'B2B Großhandel',
      'nav.newProducts': 'Neuheiten',
      'nav.topSellers': 'Bestseller',
      'nav.cart': 'Warenkorb',
      'nav.login': 'Anmelden',
      'nav.register': 'Registrieren',
      'nav.account': 'Mein Konto',
      'nav.messages': 'Nachrichten',
      'nav.orders': 'Bestellungen',
      'nav.buyerCentral': 'Käufer-Zentrum',
      'nav.seller': 'Verkäufer werden',
      'nav.help': 'Hilfe & Kontakt',
      'nav.logout': 'Abmelden',

      // Search
      'search.placeholder': 'Was suchen Sie? (Produkte, Kategorien, Lieferanten)',
      'search.button': 'Suchen',
      'search.recent': 'Letzte Suchen',
      'search.popularSearches': 'Beliebte Suchbegriffe',
      'search.resultsFor': 'Suchergebnisse für',
      'search.noResults': 'Keine Produkte gefunden',
      'search.allCategories': 'Alle Kategorien',
      'search.filter': 'Filter',
      'search.sortBy': 'Sortieren nach',
      'search.sort.relevance': 'Beste Übereinstimmung',
      'search.sort.price_asc': 'Preis: Niedrig bis Hoch',
      'search.sort.price_desc': 'Preis: Hoch bis Niedrig',
      'search.sort.newest': 'Neueste zuerst',
      'search.productsFound': '{{count}} Produkte gefunden',

      // Home - Hero
      'hero.title.prefix': 'Direkt von',
      'hero.title.highlight': 'Chinesischen Herstellern',
      'hero.title.suffix': 'kaufen',
      'hero.subtitle': 'Zugriff auf über 100 Millionen Produkte zu Fabrikpreisen mit kompletter Logistik- und Zollabwicklung für den europäischen Markt.',
      'hero.popular': 'Beliebt:',
      'hero.feature.factoryPrices': 'Fabrikpreise',
      'hero.feature.tradeAssurance': 'Käuferschutz',
      'hero.feature.globalShipping': 'EU Versand',
      'hero.feature.products': '100M+ Produkte',

      // Home - Categories
      'categories.title': 'Beliebte Kategorien durchsuchen',
      'categories.subtitle': 'Entdecken Sie Millionen von Produkten aus verschiedenen Kategorien',
      'categories.viewAll': 'Alle Kategorien anzeigen',
      'category.electronics': 'Elektronik & Computer',
      'category.fashion': 'Mode & Kleidung',
      'category.home': 'Haus & Garten',
      'category.beauty': 'Gesundheit & Beauty',
      'category.toys': 'Spielzeug & Hobbys',
      'category.sports': 'Sport & Freizeit',
      'category.machinery': 'Maschinen & Teile',
      'category.packaging': 'Verpackung & Druck',
      'category.automotive': 'Auto & Motorrad',
      'category.office': 'Büro & Schule',
      'category.bags': 'Taschen & Koffer',

      // Home - Featured
      'featured.badge': 'Top Angebote',
      'featured.title': 'Beliebte Produkte',
      'featured.subtitle': 'Die meistverkauften und bestbewerteten Artikel direkt vom Hersteller',
      'featured.viewAll': 'Alle Angebote ansehen',
      'featured.feature1.title': 'Top Bewertungen',
      'featured.feature1.desc': '4.5+ Sterne Produkte',
      'featured.feature2.title': 'Verifizierte Qualität',
      'featured.feature2.desc': 'Geprüfte Lieferanten',
      'featured.feature3.title': 'Schneller Versand',
      'featured.feature3.desc': '5-14 Tage Lieferung',

      // Home - Features Section
      'features.title': 'Warum 1688Euro?',
      'features.subtitle': 'Wir machen den direkten Import aus China einfach und sicher.',
      'features.price.title': 'Fabrikpreise',
      'features.price.desc': 'Bis zu 50% günstiger durch Direktkauf.',
      'features.customs.title': 'EU-Zollabwicklung',
      'features.customs.desc': 'Wir kümmern uns um alle Import-Formalitäten.',
      'features.protection.title': 'Käuferschutz',
      'features.protection.desc': '100% Geld-zurück-Garantie bei Problemen.',
      'features.lang.title': 'Auto-Übersetzung',
      'features.lang.desc': 'Alles automatisch auf Deutsch übersetzt.',
      'features.support.title': 'Deutscher Support',
      'features.support.desc': 'Persönliche Ansprechpartner in Europa.',
      'features.shipping.title': 'Schnelle Lieferung',
      'features.shipping.desc': 'Express-Logistiknetzwerk nach Europa.',
      'features.cta.title': 'Bereit für den Import?',
      'features.cta.subtitle': 'Kostenlos registrieren und starten.',
      'features.cta.button': 'Jetzt registrieren',

      // Home - Suppliers
      'suppliers.title': 'Verifizierte Lieferanten',
      'suppliers.subtitle': 'Direkte Verbindung zu geprüften Fabriken',
      'suppliers.viewAll': 'Alle Lieferanten',
      'suppliers.years': 'Jahre',
      'suppliers.products': 'Produkte',
      'suppliers.verified': 'Verifiziert',

      // Home - Testimonials
      'testimonials.title': 'Das sagen unsere Kunden',
      
      // CTA Section
      'cta.title': 'Starten Sie Ihr Business mit uns',
      'cta.subtitle': 'Keine versteckten Gebühren, volle Transparenz.',
      'cta.button': 'Kostenlos starten',

      // Product Card/Page
      'product.minOrder': 'Min. Bestellung',
      'product.pieces': 'Stück',
      'product.contactSupplier': 'Lieferant kontaktieren',
      'product.chatNow': 'Jetzt chatten',
      'product.addToCart': 'In den Warenkorb',
      'product.startOrder': 'Bestellung starten',
      'product.specifications': 'Spezifikationen',
      'product.description': 'Produktbeschreibung',
      'product.supplierInfo': 'Lieferanteninfos',
      'product.reviews': 'Bewertungen',
      'product.shipping': 'Versand',
      'product.shipping.desc': 'Express · Seefracht · Wird berechnet',
      'product.protection': 'Schutz',
      'product.protection.desc': 'Trade Assurance schützt Ihre Bestellung',
      'product.businessType': 'Geschäftstyp',
      'product.responseRate': 'Antwortrate',

      // Common
      'common.loading': 'Laden...',
      'common.error': 'Ein Fehler ist aufgetreten',
      'feature.tradeAssurance': 'Trade Assurance',
      'cart.secureTransaction': 'Sichere Transaktion',
    }
  },
  en: {
    translation: {
      'nav.home': 'Home',
      'nav.categories': 'Categories',
      'nav.wholesale': 'B2B Wholesale',
      'nav.newProducts': 'New Arrivals',
      'nav.topSellers': 'Top Sellers',
      'nav.cart': 'Cart',
      'nav.login': 'Sign In',
      'nav.register': 'Join Free',
      'nav.account': 'My Account',
      'nav.messages': 'Messages',
      'nav.orders': 'My Orders',
      'nav.buyerCentral': 'Buyer Central',
      'nav.seller': 'Become a Seller',
      'nav.help': 'Help Center',
      'nav.logout': 'Sign Out',

      'search.placeholder': 'What are you looking for? (products, categories, suppliers)',
      'search.button': 'Search',
      'search.recent': 'Recent Searches',
      'search.popularSearches': 'Popular Searches',
      'search.resultsFor': 'Search results for',
      'search.noResults': 'No products found',
      'search.allCategories': 'All Categories',
      'search.filter': 'Filter',
      'search.sortBy': 'Sort by',
      'search.sort.relevance': 'Best Match',
      'search.sort.price_asc': 'Price: Low to High',
      'search.sort.price_desc': 'Price: High to Low',
      'search.sort.newest': 'Newest first',
      'search.productsFound': '{{count}} products found',

      'hero.title.prefix': 'Source Directly from',
      'hero.title.highlight': 'Chinese Manufacturers',
      'hero.title.suffix': '',
      'hero.subtitle': 'Access over 100 million products at factory prices with complete logistics and customs support for the European market.',
      'hero.popular': 'Popular:',
      'hero.feature.factoryPrices': 'Factory Prices',
      'hero.feature.tradeAssurance': 'Trade Assurance',
      'hero.feature.globalShipping': 'EU Shipping',
      'hero.feature.products': '100M+ Products',

      'categories.title': 'Browse Popular Categories',
      'categories.subtitle': 'Discover millions of products across various categories',
      'categories.viewAll': 'View All Categories',
      'category.electronics': 'Electronics & Computers',
      'category.fashion': 'Fashion & Clothing',
      'category.home': 'Home & Garden',
      'category.beauty': 'Health & Beauty',
      'category.toys': 'Toys & Hobbies',
      'category.sports': 'Sports & Entertainment',
      'category.machinery': 'Machinery & Parts',
      'category.packaging': 'Packaging & Printing',
      'category.automotive': 'Automobiles & Motorcycles',
      'category.office': 'Office & School',
      'category.bags': 'Bags & Luggage',

      'featured.badge': 'Top Deals',
      'featured.title': 'Popular Products',
      'featured.subtitle': 'Best-selling and top-rated items directly from manufacturers',
      'featured.viewAll': 'View All Deals',
      'featured.feature1.title': 'Top Rated',
      'featured.feature1.desc': '4.5+ star products',
      'featured.feature2.title': 'Verified Quality',
      'featured.feature2.desc': 'Audited suppliers',
      'featured.feature3.title': 'Fast Shipping',
      'featured.feature3.desc': '5-14 days delivery',

      'features.title': 'Why 1688Euro?',
      'features.subtitle': 'We make direct importing from China simple and secure.',
      'features.price.title': 'Factory Prices',
      'features.price.desc': 'Up to 50% cheaper via direct purchase.',
      'features.customs.title': 'EU Customs Clearing',
      'features.customs.desc': 'We handle all import formalities.',
      'features.protection.title': 'Buyer Protection',
      'features.protection.desc': '100% money-back guarantee on issues.',
      'features.lang.title': 'Auto-Translation',
      'features.lang.desc': 'Everything automatically translated to English.',
      'features.support.title': 'Local Support',
      'features.support.desc': 'Personal support team in Europe.',
      'features.shipping.title': 'Fast Delivery',
      'features.shipping.desc': 'Express logistics network to Europe.',
      'features.cta.title': 'Ready to Import?',
      'features.cta.subtitle': 'Join for free and get started.',
      'features.cta.button': 'Register Now',

      'suppliers.title': 'Verified Suppliers',
      'suppliers.subtitle': 'Direct connections to audited factories',
      'suppliers.viewAll': 'All Suppliers',
      'suppliers.years': 'Years',
      'suppliers.products': 'Products',
      'suppliers.verified': 'Verified',

      'testimonials.title': 'What Our Customers Say',

      'cta.title': 'Start Your Business With Us',
      'cta.subtitle': 'No hidden fees, full transparency.',
      'cta.button': 'Get Started Free',

      'product.minOrder': 'Min. Order',
      'product.pieces': 'Pieces',
      'product.contactSupplier': 'Contact Supplier',
      'product.chatNow': 'Chat Now',
      'product.addToCart': 'Add to Cart',
      'product.startOrder': 'Start Order',
      'product.specifications': 'Specifications',
      'product.description': 'Product Description',
      'product.supplierInfo': 'Supplier Info',
      'product.reviews': 'Reviews',
      'product.shipping': 'Shipping',
      'product.shipping.desc': 'Express · Sea Freight · Calculated at checkout',
      'product.protection': 'Protection',
      'product.protection.desc': 'Trade Assurance protects your order',
      'product.businessType': 'Business Type',
      'product.responseRate': 'Response Rate',

      'common.loading': 'Loading...',
      'common.error': 'An error occurred',
      'feature.tradeAssurance': 'Trade Assurance',
      'cart.secureTransaction': 'Secure Transaction',
    }
  },
  fr: {
    translation: {
      'nav.home': 'Accueil',
      'nav.categories': 'Catégories',
      'nav.wholesale': 'B2B Gros',
      'nav.newProducts': 'Nouveautés',
      'nav.topSellers': 'Meilleures Ventes',
      'nav.cart': 'Panier',
      'nav.login': 'Connexion',
      'nav.register': 'S\'inscrire',
      'nav.account': 'Mon Compte',
      'nav.messages': 'Messages',
      'nav.orders': 'Commandes',
      'nav.buyerCentral': 'Centre Acheteur',
      'nav.seller': 'Devenir Vendeur',
      'nav.help': 'Aide',
      'nav.logout': 'Déconnexion',

      'search.placeholder': 'Que cherchez-vous ? (produits, catégories)',
      'search.button': 'Rechercher',
      'search.recent': 'Recherches récentes',
      'search.popularSearches': 'Recherches populaires',
      'search.resultsFor': 'Résultats pour',
      'search.noResults': 'Aucun produit trouvé',
      'search.allCategories': 'Toutes les catégories',
      'search.filter': 'Filtrer',
      'search.sortBy': 'Trier par',
      'search.sort.relevance': 'Pertinence',
      'search.sort.price_asc': 'Prix: Bas à Haut',
      'search.sort.price_desc': 'Prix: Haut à Bas',
      'search.sort.newest': 'Plus récents',
      'search.productsFound': '{{count}} produits trouvés',

      'hero.title.prefix': 'Achetez direct aux',
      'hero.title.highlight': 'Fabricants Chinois',
      'hero.title.suffix': '',
      'hero.subtitle': 'Accédez à plus de 100 millions de produits à prix d\'usine avec un support logistique et douanier complet pour le marché européen.',
      'hero.popular': 'Populaire:',
      'hero.feature.factoryPrices': 'Prix d\'usine',
      'hero.feature.tradeAssurance': 'Assurance Commerce',
      'hero.feature.globalShipping': 'Livraison UE',
      'hero.feature.products': '100M+ Produits',

      'categories.title': 'Parcourir les Catégories',
      'categories.subtitle': 'Découvrez des millions de produits dans diverses catégories',
      'categories.viewAll': 'Voir toutes les catégories',
      'category.electronics': 'Électronique & Ordi',
      'category.fashion': 'Mode & Vêtements',
      'category.home': 'Maison & Jardin',
      'category.beauty': 'Santé & Beauté',
      'category.toys': 'Jouets & Loisirs',
      'category.sports': 'Sports & Divertissement',
      'category.machinery': 'Machines & Pièces',
      'category.packaging': 'Emballage & Impression',
      'category.automotive': 'Auto & Moto',
      'category.office': 'Bureau & École',
      'category.bags': 'Sacs & Bagages',

      'featured.badge': 'Meilleures Offres',
      'featured.title': 'Produits Populaires',
      'featured.subtitle': 'Les articles les mieux notés directement des fabricants',
      'featured.viewAll': 'Voir tout',
      'featured.feature1.title': 'Mieux Notés',
      'featured.feature1.desc': 'Produits 4.5+ étoiles',
      'featured.feature2.title': 'Qualité Vérifiée',
      'featured.feature2.desc': 'Fournisseurs audités',
      'featured.feature3.title': 'Livraison Rapide',
      'featured.feature3.desc': 'Livraison 5-14 jours',

      'features.title': 'Pourquoi 1688Euro ?',
      'features.subtitle': 'Nous rendons l\'importation directe de Chine simple et sûre.',
      'features.price.title': 'Prix d\'usine',
      'features.price.desc': 'Jusqu\'à 50% moins cher par achat direct.',
      'features.customs.title': 'Douane UE Incluse',
      'features.customs.desc': 'Nous gérons toutes les formalités d\'importation.',
      'features.protection.title': 'Protection Acheteur',
      'features.protection.desc': 'Garantie de remboursement à 100% en cas de problème.',
      'features.lang.title': 'Traduction Auto',
      'features.lang.desc': 'Tout traduit automatiquement en Français.',
      'features.support.title': 'Support Local',
      'features.support.desc': 'Équipe de support personnelle en Europe.',
      'features.shipping.title': 'Livraison Rapide',
      'features.shipping.desc': 'Réseau logistique express vers l\'Europe.',
      'features.cta.title': 'Prêt à importer ?',
      'features.cta.subtitle': 'Inscrivez-vous gratuitement pour commencer.',
      'features.cta.button': 'S\'inscrire maintenant',

      'suppliers.title': 'Fournisseurs Vérifiés',
      'suppliers.subtitle': 'Connexions directes aux usines auditées',
      'suppliers.viewAll': 'Tous les fournisseurs',
      'suppliers.years': 'Ans',
      'suppliers.products': 'Produits',
      'suppliers.verified': 'Vérifié',

      'testimonials.title': 'Avis Clients',

      'cta.title': 'Lancez votre business avec nous',
      'cta.subtitle': 'Pas de frais cachés, transparence totale.',
      'cta.button': 'Commencer gratuitement',

      'product.minOrder': 'Commande Min.',
      'product.pieces': 'Pièces',
      'product.contactSupplier': 'Contacter le fournisseur',
      'product.chatNow': 'Discuter',
      'product.addToCart': 'Ajouter au panier',
      'product.startOrder': 'Commander',
      'product.specifications': 'Spécifications',
      'product.description': 'Description du produit',
      'product.supplierInfo': 'Info Fournisseur',
      'product.reviews': 'Avis',
      'product.shipping': 'Livraison',
      'product.shipping.desc': 'Express · Fret Maritime · Calculé à la caisse',
      'product.protection': 'Protection',
      'product.protection.desc': 'Trade Assurance protège votre commande',
      'product.businessType': 'Type d\'entreprise',
      'product.responseRate': 'Taux de réponse',

      'common.loading': 'Chargement...',
      'common.error': 'Une erreur est survenue',
      'feature.tradeAssurance': 'Trade Assurance',
      'cart.secureTransaction': 'Transaction Sécurisée',
    }
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['de', 'en', 'fr'],
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => {
        if (lng.match(/^de/)) return 'de'
        if (lng.match(/^fr/)) return 'fr'
        return 'en'
      }
    },
    interpolation: {
      escapeValue: false
    }
  })

export default i18n